import { eventBus } from '../core/EventBus';
export class ReactiveList {
    static ITEMS_CHANGED = 'items-changed';
    static SELECTION_CHANGED = 'selection-changed';
    static STATE_CHANGED = 'state-changed';
    bus;
    _options = [];
    _selection;
    _state = 'pending';
    constructor(namespace, options = []) {
        this.bus = eventBus(namespace);
        this._options = options;
    }
    on(type, callback) {
        return this.bus.on(type, callback);
    }
    setState(newState) {
        if (this._state !== newState) {
            this._state = newState;
            this.bus.emit(ReactiveList.STATE_CHANGED, newState);
        }
    }
    get state() {
        return this._state;
    }
    get options() {
        return this._options;
    }
    set options(items) {
        this._options = items;
        this.bus.emit(ReactiveList.ITEMS_CHANGED, items);
    }
    get selection() {
        return this._selection;
    }
    select(option) {
        if (this._selection?.value != option?.value) {
            this._selection = option;
            this.bus.emit(ReactiveList.SELECTION_CHANGED, option);
        }
    }
    findByLabel(label) {
        return this.options.find(o => o.label === label);
    }
    findByValue(value) {
        if (typeof value === 'string') {
            return this.options.find(o => String(o.value) === value);
        }
        return this.options.find(o => o.value === value || o.value === value);
    }
}
//# sourceMappingURL=ReactiveList.js.map